// The apps the welcome step suggests for what a company does and how many work there.

export const BUSINESSES = ["trading", "retail", "services", "appointments", "contracting", "realestate", "manufacturing", "other"] as const;
export type Business = (typeof BUSINESSES)[number];
export const TEAM_SIZES = ["1", "2-10", "11-50", "51+"] as const;
export type TeamSize = (typeof TEAM_SIZES)[number];

/** The apps for each kind of business, and those added for each team size. */
export type Onboarding = { business: Record<string, string[] | null>; team: Record<string, string[] | null> };

/** The suggestions ClientOS shipped with; the back-office's (in the platform's status) replace
 * them: a team brings its people and their pay, a bigger one approvals. */
export const shippedOnboarding: Onboarding = {
  business: {
    trading: ["crm", "invoicing", "inventory", "accounting"],
    retail: ["pos", "inventory", "invoicing", "accounting"],
    services: ["crm", "invoicing", "projects", "accounting"],
    appointments: ["appointments", "invoicing", "accounting"],
    contracting: ["projects", "invoicing", "inventory", "accounting"],
    realestate: ["realestate", "crm", "invoicing", "accounting"],
    manufacturing: ["inventory", "invoicing", "accounting"],
    other: ["invoicing"],
  },
  team: { "1": [], "2-10": ["hr", "payroll"], "11-50": ["hr", "payroll", "requests"], "51+": ["hr", "payroll", "requests"] },
};

/** The apps suggested, in the order of `available` (the plan's apps, in the menu's order). */
export function recommendedApps(business: Business | undefined, team: TeamSize | undefined, available: string[],
  onboarding: Onboarding = shippedOnboarding): string[] {
  if (!business) return [];
  const want = new Set([...(onboarding.business[business] ?? []), ...(team ? onboarding.team[team] ?? [] : [])]);
  return available.filter((a) => want.has(a));
}
